import { Node, NodeProps } from "@xyflow/react";
import { DefaultNodeData } from "@zapier/canvas-state";

import { AssetNodeProps } from "../../nodeTypes/AssetNodeSkeleton/AssetNodeDeterminer";
import { AssetNodeSkeleton } from "../AssetNodeSkeleton";

export function ChatbotNode(
  props: NodeProps<Node<DefaultNodeData>> & AssetNodeProps,
) {
  return (
    <AssetNodeSkeleton
      {...props}
      placeholder="Enter Chatbot title"
      iconName="navAIChatbot"
    />
  );
}
